<template>
  <div>
    <div v-if="!pageLoading">
      <!--    <back-nav to="PersonalDetailsHealth" />-->
      <v-card flat class="tw-mt-5 md:tw-mt-16">
        <div class="tw-px-4 md:tw-px-8">
          <card-title icon="mdi-account">Renewal Summary</card-title>
          <v-card flat color="primary" class="c-bg-navy tw-p-3 md:tw-p-6 rounded-lg tw-mt-5">
            <div class="tw-flex tw-flex-wrap md:tw-flex-no-wrap tw-items-center">
              <div class="tw-w-full md:tw-w-1/4">
                <v-icon size="80" color="white" class="">mdi-home-circle-outline</v-icon>
                <br>
                <div class="tw-w-full tw-mt-3">
                  <p class="tw-text-white">DOMESTIC PACKAGE</p>
                </div>
              </div>
              <div class="tw-text-white">
                <div class="tw-flex tw-flex-wrap tw-mb-3">
                  <p class="tw-py-2 tw-text-sm tw-w-full md:tw-w-1/2 md:tw-border-r md:tw-border-white tw-px-2 md:tw-px-4">It provides coverage for you for your hard earned assets.</p>
                  <div class="tw-px-2 md:tw-px-4">
                    <span v-if="dpRenewal.batch_number"><v-icon size="15" color="white">mdi-check-circle</v-icon> <small class="tw-text-white">Batch Number: {{ dpRenewal.batch_number }}</small><br></span>
                    <span v-if="dpRenewal.policy_number"><v-icon size="15" color="white">mdi-check-circle</v-icon> <small class="tw-text-white">Policy Number: {{ dpRenewal.policy_number }}</small><br></span>
                  </div>
                </div>
                <hr>
                <!-- <p class="tw-text-white tw-font-bold tw-mt-3">Current Limit: Ksh {{ totalLimit }}</p> -->
                <h5 class="w-full c-blue-text tw-text-xl tw-font-bold">Premium Payable: Ksh {{ dpRenewal.premium | formatNum }}</h5>
                <v-btn color="secondary" @click="proceed">Renew</v-btn>
              </div>
            </div>
          </v-card>
        </div>
      </v-card>
    </div>
    <div v-else class="tw-w-full tw-flex tw-justify-center">
      <v-progress-circular
          :size="80"
          color="primary1"
          indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import CardTitle from '@/components/shared/CardTitle';
import { mapGetters } from 'vuex';
import axios from 'axios';
import helpers from '@/utils/helpers';
// import TermsAndConditions from '@/components/TermsAndConditions';
// import ExpressUpload from '@/components/shared/ExpressUpload';

export default {
  name: 'DPRenewal',
  // components: { TermsAndConditions, CardTitle, ExpressUpload },
  components: { CardTitle },
  data() {
    return {
      pageLoading: false,
      loading: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated', 'authenticatedUser']),
    dpRenewal() {
      return this.$store.getters['renewal/dpRenewal'];
    },
  },
  methods: {
    proceed() {
      axios.post('customer/digital-quotation/domestic-package/renew/policy', this.dpRenewal).then((response) => {
        if (response.status === 200) {
          this.loading = false;
          const user = this.authenticatedUser;
          const payment = {
            payableAmount: this.dpRenewal.premium,
            kraPin: user['custom:kra-pin'],
            transactionReference: user['custom:id_number'],
            customerPhoneNumber: user.phone_number,
            transactionDescription: `DP_ren-${response.data.id}`,
          };
          const quoteInfo = {
            coverType: 'Domestic Package Cover',
            payPercentage: 100,
          };
          this.$toast.success('Renewal initiated successfully', 'Renewal');
          this.$store.commit('renewal/cleardpRenewal');
          this.$emit('to-make-payment', { data: { payment, quoteInfo } });
        } else {
          this.$toast.error('An error occured when attempting your renewal', 'Renewal');
        }
      });
    },
  },
  filters: {
    formatNum(num) {
      return helpers.numberToString(num || 10000);
    },
  },
};
</script>
